let _scheduleFlush = flushWatchers => {
    setTimeout(() => {
        flushWatchers();
    }, 0);
};
let _runBatch = fn => fn();
export function setConfig(cfg) {
    _scheduleFlush = cfg.scheduleFlush ?? _scheduleFlush;
    _runBatch = cfg.runBatch ?? _runBatch;
}
export const scheduleFlush = (fn) => {
    _scheduleFlush(fn);
};
export const runBatch = (fn) => {
    _runBatch(fn);
};
